import React from "react";
import PageHero from "../components/PageHero";
import ContactSection from "../components/ContactSection";
import { images } from "../mock/mock";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Contact() {
  return (
    <main>
      <PageHero image={images.contact} eyebrow="Get in touch" title="Contact us" subtitle="Please fill out the enquiry form and our dedicated team will promptly attend to your request." />
      <section className="bg-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 pt-16">
          <div className="grid sm:grid-cols-3 gap-6">
            {[
              { icon: MapPin, title: "Head Office", text: "72 S Emerson Avenue, Montauk, NY 11954" },
              { icon: Mail, title: "Email", text: "kelvin.marshal@oceanenergyindustrials.com" },
              { icon: Phone, title: "Phone", text: "419-408-1113" },
            ].map((c) => (
              <div key={c.title} className="border border-gray-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-12 h-12 shrink-0 rounded-lg oe-navy flex items-center justify-center">
                  <c.icon size={22} className="text-white" />
                </div>
                <div>
                  <h3 className="text-oe-navy font-semibold">{c.title}</h3>
                  <p className="text-muted-foreground text-sm mt-1">{c.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <ContactSection />
    </main>
  );
}
